"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.speeds = exports.soundfonts = exports.scoreTypes = exports.playModes = exports.partMap = exports.keySignatures = exports.groupSoundFonts = exports.getSourceKeySignaturesOptions = exports.displayModeArray = exports.PlayerToolType = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _lodash = _interopRequireDefault(require("lodash"));

/**
 * @代表为小字组（低八度）
 * 正常 代表为小字一组（正常大调）
 * #代表小字二组（高八度）
 */
var keySignatures = [{
  label: 'B',
  value: '$B'
}, {
  label: '♭B',
  value: '$bB'
}, {
  label: 'A',
  value: '$A'
}, {
  label: '♭A',
  value: '$bA'
}, {
  label: 'G',
  value: '$G'
}, {
  label: '#F',
  value: '$sF'
}, {
  label: 'F',
  value: '$F'
}, {
  label: 'E',
  value: '$E'
}, {
  label: '♭E',
  value: '$bE'
}, {
  label: 'D',
  value: '$D'
}, {
  label: '♭D',
  value: '$bD'
}, {
  label: 'C',
  value: '$C'
}, {
  label: 'B',
  value: 'B'
}, {
  label: '♭B',
  value: 'bB'
}, {
  label: 'A',
  value: 'A'
}, {
  label: '♭A',
  value: 'bA'
}, {
  label: 'G',
  value: 'G'
}, {
  label: '#F',
  value: 'sF'
}, {
  label: 'F',
  value: 'F'
}, {
  label: 'E',
  value: 'E'
}, {
  label: '♭E',
  value: 'bE'
}, {
  label: 'D',
  value: 'D'
}, {
  label: '♭D',
  value: 'bD'
}, {
  label: 'C',
  value: 'C'
}, {
  label: 'B',
  value: '@B'
}, {
  label: '♭B',
  value: '@bB'
}, {
  label: 'A',
  value: '@A'
}, {
  label: '♭A',
  value: '@bA'
}, {
  label: 'G',
  value: '@G'
}, {
  label: '#F',
  value: '@sF'
}, {
  label: 'F',
  value: '@F'
}, {
  label: 'E',
  value: '@E'
}, {
  label: '♭E',
  value: '@bE'
}, {
  label: 'D',
  value: '@D'
}, {
  label: '♭D',
  value: '@bD'
}, {
  label: 'C',
  value: '@C'
}];
exports.keySignatures = keySignatures;

var getSourceKeySignaturesOptions = function getSourceKeySignaturesOptions(keySignature) {
  var sourceKeySignatures = [];

  var _keySignatures = _lodash.default.cloneDeep(keySignatures);

  var index = _lodash.default.findIndex(_keySignatures, function (i) {
    return i.value === keySignature;
  });

  var before = _keySignatures.slice(index - 11, index);

  var after = _keySignatures.slice(index, index + 12);

  sourceKeySignatures.push.apply(sourceKeySignatures, (0, _toConsumableArray2.default)(before));
  sourceKeySignatures.push.apply(sourceKeySignatures, (0, _toConsumableArray2.default)(after));
  return sourceKeySignatures;
};

exports.getSourceKeySignaturesOptions = getSourceKeySignaturesOptions;
var speeds = [{
  label: '庄板',
  value: 40
}, {
  label: '广板',
  value: 46
}, {
  label: '慢板',
  value: 52
}, {
  label: '小广板',
  value: 56
}, {
  label: '柔板',
  value: 60
}, {
  label: '小柔板',
  value: 66
}, {
  label: '行板',
  value: 72
}, {
  label: '小行板',
  value: 80
}, {
  label: '庄严的',
  value: 88
}, {
  label: '中板',
  value: 96
}, {
  label: '小快板',
  value: 108
}, {
  label: '活跃的',
  value: 120
}, {
  label: '快板',
  value: 132
}, {
  label: '极快板',
  value: 160
}, {
  label: '急板',
  value: 184
}, {
  label: '最急板',
  value: 208
}]; // 音色，value 对应音色库里的编号

exports.speeds = speeds;
var soundfonts = [{
  value: 0,
  label: '大钢琴'
}, {
  value: 1,
  label: '明亮的钢琴'
}, {
  value: 2,
  label: '电钢琴'
}, {
  value: 3,
  label: '酒吧钢琴'
}, {
  value: 4,
  label: '柔和的电钢琴'
}, {
  value: 5,
  label: '加合唱效果的电钢琴'
}, {
  value: 6,
  label: '羽管键琴（拨弦古钢琴）'
}, {
  value: 7,
  label: '科拉维科特琴（击弦古钢琴）'
}, {
  value: 8,
  label: '钢片琴'
}, {
  value: 9,
  label: '钟琴'
}, {
  value: 10,
  label: '八音盒'
}, {
  value: 11,
  label: '颤音琴'
}, {
  value: 12,
  label: '马林巴琴'
}, {
  value: 13,
  label: '木琴'
}, {
  value: 14,
  label: '管钟'
}, {
  value: 15,
  label: '大扬琴'
}, {
  value: 16,
  label: '击杆风琴'
}, {
  value: 17,
  label: '打击式风琴'
}, {
  value: 18,
  label: '摇滚风琴'
}, {
  value: 19,
  label: '教堂风琴'
}, {
  value: 20,
  label: '簧管风琴'
}, {
  value: 21,
  label: '手风琴'
}, {
  value: 22,
  label: '口琴'
}, {
  value: 23,
  label: '探戈手风琴'
}, {
  value: 24,
  label: '尼龙弦吉他'
}, {
  value: 25,
  label: '钢弦吉他'
}, {
  value: 26,
  label: '爵士电吉他'
}, {
  value: 27,
  label: '清音电吉他'
}, {
  value: 28,
  label: '闷音电吉他'
}, {
  value: 29,
  label: '加驱动效果的电吉他'
}, {
  value: 30,
  label: '加失真效果的电吉他'
}, {
  value: 31,
  label: '吉他和音'
}, {
  value: 32,
  label: '大贝司（声学贝司）'
}, {
  value: 33,
  label: '电贝司（指弹）'
}, {
  value: 34,
  label: '电贝司（拨片）'
}, {
  value: 35,
  label: '无品贝司'
}, {
  value: 36,
  label: '掌击贝司1'
}, {
  value: 37,
  label: '掌击贝司2'
}, {
  value: 38,
  label: '电子合成贝司1'
}, {
  value: 39,
  label: '电子合成贝司2'
}, {
  value: 40,
  label: '小提琴'
}, {
  value: 41,
  label: '中提琴'
}, {
  value: 42,
  label: '大提琴'
}, {
  value: 43,
  label: '低音大提琴'
}, {
  value: 44,
  label: '弦乐群颤音'
}, {
  value: 45,
  label: '弦乐群拨弦'
}, {
  value: 46,
  label: '竖琴'
}, {
  value: 47,
  label: '定音鼓'
}, {
  value: 48,
  label: '弦乐合奏1'
}, {
  value: 49,
  label: '弦乐合奏2'
}, {
  value: 50,
  label: '合成弦乐合奏1'
}, {
  value: 51,
  label: '合成弦乐合奏2'
}, {
  value: 52,
  label: '人声合唱“啊”'
}, {
  value: 53,
  label: '人声“嘟”'
}, {
  value: 54,
  label: '合成人声'
}, {
  value: 55,
  label: '管弦乐敲击齐奏'
}, {
  value: 56,
  label: '小号'
}, {
  value: 57,
  label: '长号'
}, {
  value: 58,
  label: '大号'
}, {
  value: 59,
  label: '加弱音器小号'
}, {
  value: 60,
  label: '法国号（圆号）'
}, {
  value: 61,
  label: '铜管组（铜管乐器合奏音色）'
}, {
  value: 62,
  label: '合成铜管音色1'
}, {
  value: 63,
  label: '合成铜管音色2'
}, {
  value: 64,
  label: '高音萨克斯风'
}, {
  value: 65,
  label: '次中音萨克斯风'
}, {
  value: 66,
  label: '中音萨克斯风'
}, {
  value: 67,
  label: '低音萨克斯风'
}, {
  value: 68,
  label: '双簧管'
}, {
  value: 69,
  label: '英国管'
}, {
  value: 70,
  label: '巴松（大管）'
}, {
  value: 71,
  label: '单簧管（黑管）'
}, {
  value: 72,
  label: '短笛'
}, {
  value: 73,
  label: '长笛'
}, {
  value: 74,
  label: '竖笛'
}, {
  value: 75,
  label: '排箫'
}, {
  value: 76,
  label: '芦笛'
}, {
  value: 77,
  label: '日本尺八'
}, {
  value: 78,
  label: '口哨声'
}, {
  value: 79,
  label: '奥卡雷那'
}, {
  value: 80,
  label: '合成主音1（方波）'
}, {
  value: 81,
  label: '合成主音2（锯齿波）'
}, {
  value: 82,
  label: '合成主音3'
}, {
  value: 83,
  label: '合成主音4'
}, {
  value: 84,
  label: '合成主音5'
}, {
  value: 85,
  label: '合成主音6（人声）'
}, {
  value: 86,
  label: '合成主音7（平行五度）'
}, {
  value: 87,
  label: '合成主音8（贝司加主音）'
}, {
  value: 88,
  label: '合成音色1（新世纪）'
}, {
  value: 89,
  label: '合成音色2（温暖）'
}, {
  value: 90,
  label: '合成音色3'
}, {
  value: 91,
  label: '合成音色4（合唱）'
}, {
  value: 92,
  label: '合成音色5'
}, {
  value: 93,
  label: '合成音色6（金属声）'
}, {
  value: 94,
  label: '合成音色7（光环）'
}, {
  value: 95,
  label: '合成音色8'
}, {
  value: 96,
  label: '合成效果1雨声'
}, {
  value: 97,
  label: '合成效果2音轨'
}, {
  value: 98,
  label: '合成效果3水晶'
}, {
  value: 99,
  label: '合成效果4大气'
}, {
  value: 100,
  label: '合成效果5明亮'
}, {
  value: 101,
  label: '合成效果6鬼怪'
}, {
  value: 102,
  label: '合成效果7回声'
}, {
  value: 103,
  label: '合成效果8科幻'
}, {
  value: 104,
  label: '西塔尔（印度）'
}, {
  value: 105,
  label: '班卓琴（美洲）'
}, {
  value: 106,
  label: '三昧线（日本）'
}, {
  value: 107,
  label: '十三弦筝（日本）'
}, {
  value: 108,
  label: '卡林巴'
}, {
  value: 109,
  label: '风笛'
}, {
  value: 110,
  label: '民族提琴'
}, {
  value: 111,
  label: '山奈'
}, {
  value: 112,
  label: '叮当铃'
}, {
  value: 113,
  label: 'agogo'
}, {
  value: 114,
  label: '钢鼓'
}, {
  value: 115,
  label: '木鱼'
}, {
  value: 116,
  label: '太鼓'
}, {
  value: 117,
  label: '通通鼓'
}, {
  value: 118,
  label: '合成鼓'
}, {
  value: 119,
  label: '铜钹'
}, {
  value: 120,
  label: '吉他换把杂音'
}, {
  value: 121,
  label: '呼吸声'
}, {
  value: 122,
  label: '海浪声'
}, {
  value: 123,
  label: '鸟鸣'
}, {
  value: 124,
  label: '电话铃'
}, {
  value: 125,
  label: '直升机'
}, {
  value: 126,
  label: '鼓掌声'
}, {
  value: 127,
  label: '枪声'
}];
exports.soundfonts = soundfonts;
var groupSoundFonts = [{
  group: '钢琴类',
  data: [{
    label: '大钢琴',
    value: 0,
    name: 'grandpiano'
  }, {
    label: '明亮的钢琴',
    value: 1,
    name: 'brightpiano'
  }, {
    label: '电钢琴',
    value: 2,
    name: 'electricpiano'
  }, {
    label: '酒吧钢琴',
    value: 3,
    name: 'barpiano'
  }, {
    label: '柔和的电钢琴',
    value: 4,
    name: 'electricpiano'
  }, {
    label: '加合唱效果的电钢琴',
    value: 5,
    name: 'electricpiano'
  }, {
    label: '羽管键琴（拨弦古钢琴）',
    value: 6,
    name: 'harpsichord'
  }, {
    label: '科拉维科特琴（击弦古钢琴）',
    value: 7,
    name: 'coravikot'
  }]
}, {
  group: '弦乐类',
  data: [{
    label: '小提琴',
    value: 40,
    name: 'violin'
  }, {
    label: '中提琴',
    value: 41,
    name: 'viola'
  }, {
    label: '大提琴',
    value: 42,
    name: 'cello'
  }, {
    label: '低音大提琴',
    value: 43,
    name: 'basscello'
  }, {
    label: '弦乐群颤音',
    value: 44,
    name: 'stringgroupvibrato'
  }, {
    label: '弦乐群拨弦',
    value: 45,
    name: 'stringgroupplucking'
  }, {
    label: '竖琴',
    value: 46,
    name: 'harp'
  }]
}, {
  group: '铜管类',
  data: [{
    label: '小号',
    value: 56,
    name: 'trumpet'
  }, {
    label: '长号',
    value: 57,
    name: 'trombone'
  }, {
    label: '大号',
    value: 58,
    name: 'tuba'
  }, {
    label: '加弱音器小号',
    value: 59,
    name: 'trumpet'
  }, {
    label: '法国号（圆号）',
    value: 60,
    name: 'frenchhorn'
  }, {
    label: '铜管组（铜管乐器合奏音色）',
    value: 61
  }, {
    label: '合成铜管音色1',
    value: 62
  }, {
    label: '合成铜管音色2',
    value: 63
  }]
}, {
  group: '簧管类',
  data: [{
    label: '高音萨克斯风',
    value: 64,
    name: 'saxophone'
  }, {
    label: '次中音萨克斯风',
    value: 65,
    name: 'saxophone'
  }, {
    label: '中音萨克斯风',
    value: 66,
    name: 'saxophone'
  }, {
    label: '低音萨克斯风',
    value: 67,
    name: 'basssaxophone'
  }, {
    label: '双簧管',
    value: 68,
    name: 'oboe'
  }, {
    label: '英国管',
    value: 69,
    name: 'englishhorn'
  }, {
    label: '巴松（大管）',
    value: 70,
    name: 'bassoon'
  }, {
    label: '单簧管（黑管）',
    value: 71,
    name: 'clarinet'
  }]
}, {
  group: '笛类',
  data: [{
    label: '短笛',
    value: 72,
    name: 'piccolo'
  }, {
    label: '长笛',
    value: 73,
    name: 'flute'
  }, {
    label: '竖笛',
    value: 74,
    name: 'shudi'
  }, {
    label: '排箫',
    value: 75,
    name: 'panpipe'
  }, {
    label: '芦笛',
    value: 76,
    name: 'reedflute'
  }, {
    label: '日本尺八',
    value: 77,
    name: 'shakuhachi'
  }, {
    label: '口哨声',
    value: 78
  }, {
    label: '奥卡雷那',
    value: 79
  }]
}, {
  group: '风琴类',
  data: [{
    label: '击杆风琴',
    value: 16,
    name: 'rockorgan'
  }, {
    label: '打击式风琴',
    value: 17,
    name: 'rockorgan'
  }, {
    label: '摇滚风琴',
    value: 18,
    name: 'rockorgan'
  }, {
    label: '教堂风琴',
    value: 19,
    name: 'churchorgan'
  }, {
    label: '簧管风琴',
    value: 20,
    name: 'reedorgan'
  }, {
    label: '手风琴',
    value: 21,
    name: 'accordion'
  }, {
    label: '口琴',
    value: 22,
    name: 'harmonica'
  }, {
    label: '探戈手风琴',
    value: 23,
    name: 'accordion'
  }]
}, {
  group: '民间乐器类',
  data: [{
    label: '西塔尔（印度）',
    value: 104,
    name: 'sitar'
  }, {
    label: '班卓琴（美洲）',
    value: 105,
    name: 'banjo'
  }, {
    label: '三昧线（日本）',
    value: 106,
    name: 'shamisen'
  }, {
    label: '十三弦筝（日本）',
    value: 107,
    name: 'thirteen'
  }, {
    label: '卡林巴',
    value: 108,
    name: 'kalimba'
  }, {
    label: '风笛',
    value: 109,
    name: 'airwhistle'
  }, {
    label: '民族提琴',
    value: 110,
    name: 'violin'
  }, {
    label: '山奈',
    value: 111
  }]
}, {
  group: '吉他&贝斯类',
  data: [{
    label: '尼龙弦吉他',
    value: 24,
    name: 'guitar'
  }, {
    label: '钢弦吉他',
    value: 25,
    name: 'steelguitar'
  }, {
    label: '爵士电吉他',
    value: 26,
    name: 'jazzguitar'
  }, {
    label: '清音电吉他',
    value: 27,
    name: 'dianjita'
  }, {
    label: '闷音电吉他',
    value: 28,
    name: 'dianjita'
  }, {
    label: '加驱动效果的电吉他',
    value: 29,
    name: 'dianjita'
  }, {
    label: '加失真效果的电吉他',
    value: 30,
    name: 'dianjita'
  }, {
    label: '吉他和音',
    value: 31,
    name: 'guitar'
  }, {
    label: '大贝司（声学贝司）',
    value: 32,
    name: 'bigbass'
  }, {
    label: '电贝司（指弹）',
    value: 33,
    name: 'electricbass'
  }, {
    label: '电贝司（拨片）',
    value: 34,
    name: 'electricbass'
  }, {
    label: '无品贝司',
    value: 35,
    name: 'electricbass'
  }, {
    label: '掌击贝司1',
    value: 36,
    name: 'electricbass'
  }, {
    label: '掌击贝司2',
    value: 37,
    name: 'electricbass'
  }, {
    label: '电子合成贝司1',
    value: 38,
    name: 'electricbass'
  }, {
    label: '电子合成贝司2',
    value: 39,
    name: 'electricbass'
  }]
}, {
  group: '色彩打击乐器类',
  data: [{
    label: '钢片琴',
    value: 8,
    name: 'celesta'
  }, {
    label: '钟琴',
    value: 9,
    name: 'glockenspiel'
  }, {
    label: '八音盒',
    value: 10,
    name: 'musicbox'
  }, {
    label: '颤音琴',
    value: 11,
    name: 'vibraphone'
  }, {
    label: '马林巴琴',
    value: 12,
    name: 'marimba'
  }, {
    label: '木琴',
    value: 13,
    name: 'xylophone'
  }, {
    label: '管钟',
    value: 14,
    name: 'tubularbells'
  }, {
    label: '大扬琴',
    value: 15,
    name: 'bigdulcimer'
  }]
}, {
  group: '打击乐器类',
  data: [{
    label: '定音鼓',
    value: 47,
    name: 'kettledrum'
  }, {
    label: '叮当铃',
    value: 112,
    name: 'dingdangbell'
  }, {
    label: 'agogo',
    value: 113,
    name: 'agogo'
  }, {
    label: '钢鼓',
    value: 114,
    name: 'steeldrum'
  }, {
    label: '木鱼',
    value: 115,
    name: 'woodenfish'
  }, {
    label: '太鼓',
    value: 116,
    name: 'osu'
  }, {
    label: '通通鼓',
    value: 117,
    name: 'tomtom'
  }, {
    label: '合成鼓',
    value: 118
  }, {
    label: '铜钹',
    value: 119,
    name: 'cymbal'
  }]
}, {
  group: '合奏&合唱类',
  data: [{
    label: '弦乐合奏1',
    value: 48
  }, {
    label: '弦乐合奏2',
    value: 49
  }, {
    label: '合成弦乐合奏1',
    value: 50
  }, {
    label: '合成弦乐合奏2',
    value: 51
  }, {
    label: '人声合唱“啊”',
    value: 52,
    name: 'vocalah'
  }, {
    label: '人声“嘟”',
    value: 53,
    name: 'vocaldu'
  }, {
    label: '合成人声',
    value: 54
  }, {
    label: '管弦乐敲击齐奏',
    value: 55
  }]
}, {
  group: '合成类',
  data: [{
    label: '合成主音1（方波）',
    value: 80
  }, {
    label: '合成主音2（锯齿波）',
    value: 81
  }, {
    label: '合成主音3',
    value: 82
  }, {
    label: '合成主音4',
    value: 83
  }, {
    label: '合成主音5',
    value: 84
  }, {
    label: '合成主音6（人声）',
    value: 85
  }, {
    label: '合成主音7（平行五度）',
    value: 86
  }, {
    label: '合成主音8（贝司加主音）',
    value: 87
  }, {
    label: '合成音色1（新世纪）',
    value: 88
  }, {
    label: '合成音色2（温暖）',
    value: 89
  }, {
    label: '合成音色3',
    value: 90
  }, {
    label: '合成音色4（合唱）',
    value: 91
  }, {
    label: '合成音色5',
    value: 92
  }, {
    label: '合成音色6（金属声）',
    value: 93
  }, {
    label: '合成音色7（光环）',
    value: 94
  }, {
    label: '合成音色8',
    value: 95
  }, {
    label: '合成效果1雨声',
    value: 96
  }, {
    label: '合成效果2音轨',
    value: 97
  }, {
    label: '合成效果3水晶',
    value: 98
  }, {
    label: '合成效果4大气',
    value: 99
  }, {
    label: '合成效果5明亮',
    value: 100
  }, {
    label: '合成效果6鬼怪',
    value: 101
  }, {
    label: '合成效果7回声',
    value: 102
  }, {
    label: '合成效果8科幻',
    value: 103
  }]
}, {
  group: '声音效果类',
  data: [{
    label: '吉他换把杂音',
    value: 120,
    name: 'guitar'
  }, {
    label: '呼吸声',
    value: 121,
    name: 'breath'
  }, {
    label: '海浪声',
    value: 122,
    name: 'wave'
  }, {
    label: '鸟鸣',
    value: 123,
    name: 'birds'
  }, {
    label: '电话铃',
    value: 124,
    name: 'phoneringing'
  }, {
    label: '直升机',
    value: 125,
    name: 'helicopter'
  }, {
    label: '鼓掌声',
    value: 126,
    name: 'applause'
  }, {
    label: '枪声',
    value: 127,
    name: 'gunshot'
  }]
}]; // 播放模式

exports.groupSoundFonts = groupSoundFonts;
var playModes = [{
  label: '范唱',
  value: 'ori'
}, {
  label: '伴唱',
  value: 'acc'
}, {
  label: '节奏',
  value: 'rhythm'
}, {
  label: '演奏',
  value: 'midiNoVolume'
}, {
  label: '曲谱',
  value: 'midi'
}, {
  label: '唱名',
  value: 'rollCall'
}];
exports.playModes = playModes;
var PlayerToolType;
exports.PlayerToolType = PlayerToolType;

(function (PlayerToolType) {
  PlayerToolType["Midi"] = "MIDI";
  PlayerToolType["Midi_AB"] = "MIDI-AB";
  PlayerToolType["Mp3"] = "MP3";
  PlayerToolType["Mp3_AB"] = "MP3-AB";
  PlayerToolType["SoundTouch"] = "SOUNDTOUCH";
  PlayerToolType["SoundTouch_AB"] = "SOUNDTOUCH-AB";
  PlayerToolType["RePlay_Mp3"] = "REPLAY-MP3";
  PlayerToolType["RePlay_Mp3_AB"] = "REPLAY-MP3-AB";
})(PlayerToolType || (exports.PlayerToolType = PlayerToolType = {}));

var partMap = {
  1: '第一声部',
  2: '第二声部',
  3: '第三声部',
  4: '第四声部',
  5: '第五声部',
  6: '第六声部',
  7: '第七声部',
  8: '第八声部',
  9: '第九声部',
  10: '第十声部'
}; //评分类型

exports.partMap = partMap;
var scoreTypes = [{
  label: '演唱',
  value: 0
}, {
  label: '葫芦丝',
  value: 1
}, {
  label: '竹笛',
  value: 2
}, {
  label: '陶笛',
  value: 3
}, {
  label: '竖笛',
  value: 4
}, {
  label: '口风琴',
  value: 5
}];
exports.scoreTypes = scoreTypes;
var displayModeArray = [{
  label: '简谱',
  value: 0
}, {
  label: '线谱',
  value: 1
}, {
  label: '简线',
  value: 2
}];
exports.displayModeArray = displayModeArray;